import type { VerificationTier } from './types';

export const TEST_ID = 'formulationReviewModal';

export const VERIFY_PERMISSION = 'chemicals:verify';

// Confirmations made from this panel always quote a label or SDS sentence.
export const VERIFICATION_TIER: VerificationTier = 'DOCUMENT';

export const EVIDENCE_MIN_LENGTH = 10;

export const EVIDENCE_MAX_LENGTH = 2000;

export const LABEL_MIXING_NOTE_MAX_LENGTH = 2000;

// Codes chemical-db-api accepts on PUT formulation-verification (VERIFIABLE_CODES).
export const VERIFIABLE_CODES = new Set([
    'ADJ',
    'CS',
    'DF',
    'EC',
    'EW',
    'G',
    'SC',
    'SE',
    'SG',
    'SL',
    'SP',
    'WC',
    'WDG',
    'WP',
    'WSP'
]);
